module.exports = __webpack_public_path__ + "static/media/cancelSummery.0ba51c9b.svg";